import { CircleFlag } from 'react-circle-flags'
import { getFormattedDate, getTypeKey } from 'utils'
import type { RegionsDetailData } from '@contracts'
import styles from './RegionsTabView.module.scss'

export const columnStructure = [
  {
    headerName: 'Region',
    field: getTypeKey<RegionsDetailData>('name'),
    sortable: true,
    flex: 1,
    resizable: true,
    cellRenderer: ({ data }: { data: RegionsDetailData }) => (
      <div className={styles.regionCell}>
        <CircleFlag countryCode={data?.flag} height={24} />
        {data?.name}
      </div>
    ),
  },
  {
    headerName: 'Language',
    field: getTypeKey<RegionsDetailData>('locale'),
    sortable: true,
    flex: 1,
    resizable: true,
    valueFormatter: ({ value }: { value: string }) => value?.toUpperCase().replace('_', ' - '),
  },
  {
    headerName: 'Created',
    field: getTypeKey<RegionsDetailData>('created_at'),
    sortable: true,
    flex: 1,
    resizable: true,
    valueFormatter: ({ value }: { value: string }) => getFormattedDate(value),
  },
]
